import React from 'react';
import Header from "./Header.js";
import Hero from "./Hero.js";
import Footer from "./Footer.js";
import './freelancerhome.css';

function FreelancerMode() {
  return (
    <div>
      <Header/>
      <Hero/> 
      <Footer/> 
    </div>
  );
}

export default FreelancerMode;